@if (infographic) {
  <div class="row infographic noSidebar m-0 p-0">
    <div class="img-wrap">
      <img
        [src]="infographic.backgroundImage"
        width="100%"
        id="infographic-image"
        />
      @for (hotspot of infographic.hotspots; track hotspot; let i = $index) {
        <div
          class="hotspot-button"
          id="hotspot{{ i }}"
          [ngClass]="{ active: isActive(i) }"
          [ngStyle]="getButtonStyle(hotspot)"
          (click)="toggleHotspot($event, i)"
          >
          <i class="fas fa-plus"></i>
        </div>
      }
    </div>
    @for (hotspot of infographic.hotspots; track hotspot; let i = $index) {
      <div
        [ngClass]="{
          active: isActive(i),
          'hotspot-popup': true,
          'true-popup': true
        }"
        [ngStyle]="positionRelativeToCursor()"
        >
        @if (hotspot.image) {
          <img [src]="hotspot.image" />
        }
        @if (hotspot.title) {
          <h3>{{ hotspot.title }}</h3>
        }
        @if (hotspot.description) {
          <p [innerHTML]="hotspot.description"></p>
        }
        @if (hotspot.link) {
          <a
            class="btn btn-dark"
            [href]="hotspot.link"
            target="_blank"
            >Learn More</a
            >
          }
        </div>
      }
    </div>
  }
